import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "I learned two things today 1.8.",
  "description": "",
  "published": "2011-08-01T00:00:00.000Z",
  "redirect_from": ["/blog/i-learned-two-things-today-1-8/swizec/2054"],
  "categories": "BJ Fogg, Design, Learning, Personal, Product design, Psychology, Tea, Twitter",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Today I might have accidentally learned more than two things, for which I am deeply sorry and I do apologize.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/08/dbef20877a0c4b5fb6bf32c8b95fdb1e_73.jpg",
        "alt": null,
        "title": "Captivity graph"
      }}></img></p>
    <p>{`The most mind blowing thing I learned today was a simple lesson in `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Product_design",
        "title": "Product design"
      }}>{`product design`}</a>{`. `}<a parentName="p" {...{
        "href": "https://twitter.com/#!/tantadruj"
      }}>{`@tantadruj`}</a>{` was at some very expensive seminar by `}<a parentName="p" {...{
        "href": "http://www.bjfogg.com/",
        "title": "BJ Fogg"
      }}>{`BJ Fogg`}</a>{` last week and he explained the basic concept of making products that captivate people and make them come back later.`}</p>
    <p>{`Distilled to its very core the key takeaway is that you should keep reminding your users that they are using your product. If you don't remind them, they will forget no matter how much they might need it or how highly motivated they are to doing something.`}</p>
    <p>{`People forget shit. They do.`}</p>
    <p>{`Once you start thinking about it, it becomes pretty obvious that people tend not to do the things they forget to do. And more importantly, every single service alive and doing well today is full of triggers. Sending you notifications one way or another ... even `}<a parentName="p" {...{
        "href": "http://bufferapp.com/"
      }}>{`Buffer`}</a>{`, the product/startup I've been watching most closely lately because they look really cool, has one basic feature that kept me coming back initially until I got the hang of using them -> every once in a while I'd get an email basically saying, "Hey, you haven't used the service in a bit, you totally should".`}</p>
    <p>{`Anyway, onward to the second thing that I learned.`}</p>
    <p>{`The other thing that I learned isn't as useful. It's just that I really really love tea and am a complete and total addict. Yes, there you have it ... Hello, I am Swizec and I am addicted to tea.`}</p>
    <p>{`Tried going without a drop the last three days and it was hell on earth. At times I questioned my sanity and whether I even want to continue living under these brutal conditions. But I persevered and my reward was ... that's right, a big ol' `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Tea",
        "title": "Tea"
      }}>{`cup of tea`}</a>{` right for breakfast. If anyone tries to convince me I might be too addicted ever again, I'm biting their nose off.`}</p>
    <p>{`You have been warned.`}</p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://swizec.com/blog/i-learned-two-things-today-31-7/swizec/2040"
        }}>{`I learned two things today 31.7`}</a>{` (swizec.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://swizec.com/blog/i-learned-two-things-today-29-7/swizec/2022"
        }}>{`I learned two things today 29.7.`}</a>{` (swizec.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.businessinsider.com/how-do-i-stop-being-so-damn-lazy-2011-7"
        }}>{`How do I stop being so damn lazy?`}</a>{` (businessinsider.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.businessinsider.com/case-study-how-jennifer-tripled-her-rate-working-13-the-hours-by-mastering-the-art-of-networking-2011-6"
        }}>{`Case Study: How Jennifer tripled her rate (working 1/3 the hours) by mastering the art of networking`}</a>{` (businessinsider.com)`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=fe6de0b4-b119-4528-bdec-f6106c75c30e",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      